import _ from 'lodash';
import {
  call,
  put,
  select,
  fork,
  takeLatest
} from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import {
  getFormValues,
  change
} from 'redux-form';
import {
  removeNonDigits
} from '../../../../../util/form/normalization';
import {
  cleanJsonInResponse
} from '../../../../../util/helpers';
import {
  LOAD_CUSTOMER,
  MOVE_CUSTOMER,
  GET_SUGGESTIONS,
  SELECT_SUGGESTION,
  DL_PAGE_LOADED
} from './localization';
import {
  SET_DATA,
  customerSelector,
  moveToAddressSelector
} from '../../../data/customer/customer';
import loader from '../../../../../util/loader/loader';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {
  navigationRoutes,
  navigationSteps
} from '../../../navigation/navigationHelpers';
import {
  showGlobalSpinner,
  hideGlobalSpinner,
  errorPageByFlow
} from '../../../common/common';
import {setSuggestions} from '../../../suggestions/suggestions';

// WATCHERS
export function* loadCustomerWatch() {
  yield takeLatest(LOAD_CUSTOMER, loadCustomerWorker);
}
export function* moveCustomergWatch() {
  yield takeLatest(MOVE_CUSTOMER, moveCustomergWorker);
}
export function* localizeSuggestionsWatch() {
  yield takeLatest(GET_SUGGESTIONS, localizeSuggestionsWorker);
}
export function* selectSuggestionsWatch() {
  yield takeLatest(SELECT_SUGGESTION, selectSuggestionWorker);
}

// WORKERS
export function* loadCustomerWorker() {
  try {
    yield put(showGlobalSpinner({hideContent: true, initiator: 'localize load'}));

    const errorPage = yield select(errorPageByFlow);
    const success = yield call(dataProvider.load, [
      {state: 'auth'},
      {state: 'customer', alwaysCall: true},
      {state: 'context'}
    ], {errorPage});

    if (!success) {
      return;
    }

    yield put({
      type: DL_PAGE_LOADED
    });

    yield put(hideGlobalSpinner());
  } catch(e) {
    yield put(hideGlobalSpinner());
    browserHistory.push(navigationRoutes[navigationSteps.movers.ERROR].path);
  }
}

export function* moveCustomergWorker() {
  const state = yield select();
  const errorPage = yield select(errorPageByFlow);

  const customer = yield select(customerSelector);
  const authEndpoint = navigationRoutes[navigationSteps.myPlan.MYPLAN].endpoints.validateAuth();
  const moveCustomerEndpoint = navigationRoutes[navigationSteps.movers.LOCALIZATION].endpoints.moveCustomer();
  const values = getFormValues('movers')(state); // state.form.movers.fields;
  const data = {
    "address": {
      "streetAddress": values.streetAddress,
      "unitNumber": values.unitNumber,
      "zipCode": values.zipCode
    },
    "serviceStopDate": values.serviceStopDate, // "2016-11-17"
    "telephoneNumber": removeNonDigits(values.phoneNumber)
  };
  const currentMoveTo = yield select(moveToAddressSelector);

  try {

    const postLoad = function* () {
      const customerWithUpdates = !_.isEqual(data.address, currentMoveTo)
      ? {
          customer: {
            ...customer,
            serviceStopDate: _.get(data, 'serviceStopDate'),
            moveToAddress: {
              streetAddress: _.get(data, 'address.streetAddress'),
              unitNumber: _.get(data, 'address.unitNumber'),
              zipCode: _.get(data, 'address.zipCode')
            }
          }
        }
      : {
          customer: {
            ...customer,
            serviceStopDate: _.get(data, 'serviceStopDate')
          }
        };

      yield put({
        type: SET_DATA,
        payload: customerWithUpdates
      });
    };

    yield put(showGlobalSpinner({hideContent: false, initiator: 'calling moveCustomer'}));
    yield call(loader.request, authEndpoint, {useGlobalSpinner: false, errorPage});
    yield call(loader.request, moveCustomerEndpoint, {data, useGlobalSpinner: false, postLoad, postLoadOnError: false, errorPage});
    yield put(hideGlobalSpinner());
  } catch(e) {
    //console.log(e);
  }
}

export function* localizeSuggestionsWorker(action) {
  const errorPage = yield select(errorPageByFlow);
  const localizeSuggestionsEndpoint = navigationRoutes[navigationSteps.movers.LOCALIZATION].endpoints.getSuggestions(action.payload.search);

  try {
    const localizeSuggestions = yield call(loader.request, localizeSuggestionsEndpoint, {useGlobalSpinner: false, errorPage});
    const cleanPropsFromResponse = cleanJsonInResponse(localizeSuggestions.data); //Learn team uses capitals in thier props

    yield put(setSuggestions('localizeSuggestions', cleanPropsFromResponse));
  } catch(e) {
    // console.log(e);
  }
}

export function* selectSuggestionWorker(action) {
  const address = action.payload.suggestion.address,
        streetAddress = address.address_StreetAddress || '',
        unitNumber = address.address_UnitNumber || '',
        zipCode = address.address_ZipCode || '';

  yield put(change('movers', 'streetAddress', streetAddress));
  yield put(change('movers', 'unitNumber', unitNumber));
  yield put(change('movers', 'zipCode', zipCode));
}

export default function* moversLocalizationSagas() {
  yield [
    fork(loadCustomerWatch),
    fork(moveCustomergWatch),
    fork(localizeSuggestionsWatch),
    fork(selectSuggestionsWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/localization/localizationSagas.js
 **/